<script type="text/javascript">

  import GoogleMapsLoader from 'google-maps';
  import MarkerClusterer from 'marker-clusterer-plus';
  var MarkerWithLabel = null;
  // GoogleMapsLoader.KEY = process.env.MIX_GOOGLE_MAPS_ID;
  GoogleMapsLoader.LIBRARIES = ['places'];

  let mapBig = null;
  let searchBox = null;
  let isMapDragging = false;
  let idleSkipped = false;
  let markerCluster = null;

  import VLazyImage from "v-lazy-image/v2";

  export default {
    props: ['type', 'pc', 'website'],
    components: { VLazyImage },
    data() {
      return {
        // Widget
        default_content: {
          type: 'listings-map',
          title: 'Listings map',
          active: 1,
          listings_source: 'listings',
          latitude: '33.504388124742675',
          longitude: '-111.87102899492187',
          zoom: 10,
          filt_bg_color: 'white',
          filt_btn_color: 'white',
          filt_btn_border_color: 'light',
          filt_btn_active_border_color: 'success',
          res_bg_color: 'gray-100',
          h1: 'Homes for sale in AZ',
          h1_color: '',
          h1_desc: '',
          h1_desc_color: '',
          box_bg_color: 'white',
          box_title_color: 'black',
          box_text_color: 'gray-700',
          map_bub_active_color: 'success',
          map_bub_closed_color: 'gray-700',
          map_bub_company_color: 'revinre',
          map_google_style: "[ { \"featureType\": \"administrative\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#6195a0\" } ] }, { \"featureType\": \"administrative.province\", \"elementType\": \"geometry.stroke\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"landscape\", \"elementType\": \"geometry\", \"stylers\": [ { \"lightness\": \"0\" }, { \"saturation\": \"0\" }, { \"color\": \"#f5f5f2\" }, { \"gamma\": \"1\" } ] }, { \"featureType\": \"landscape.man_made\", \"elementType\": \"all\", \"stylers\": [ { \"lightness\": \"-3\" }, { \"gamma\": \"1.00\" } ] }, { \"featureType\": \"landscape.natural.terrain\", \"elementType\": \"all\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"poi\", \"elementType\": \"all\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"poi.park\", \"elementType\": \"geometry.fill\", \"stylers\": [ { \"color\": \"#bae5ce\" }, { \"visibility\": \"on\" } ] }, { \"featureType\": \"road\", \"elementType\": \"all\", \"stylers\": [ { \"saturation\": -100 }, { \"lightness\": 45 }, { \"visibility\": \"simplified\" } ] }, { \"featureType\": \"road.highway\", \"elementType\": \"all\", \"stylers\": [ { \"visibility\": \"simplified\" } ] }, { \"featureType\": \"road.highway\", \"elementType\": \"geometry.fill\", \"stylers\": [ { \"color\": \"#fac9a9\" }, { \"visibility\": \"simplified\" } ] }, { \"featureType\": \"road.highway\", \"elementType\": \"labels.text\", \"stylers\": [ { \"color\": \"#4e4e4e\" } ] }, { \"featureType\": \"road.arterial\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#787878\" } ] }, { \"featureType\": \"road.arterial\", \"elementType\": \"labels.icon\", \"stylers\": [ { \"visibility\": \"off\" } ] }, { \"featureType\": \"transit\", \"elementType\": \"all\", \"stylers\": [ { \"visibility\": \"simplified\" } ] }, { \"featureType\": \"transit.station.airport\", \"elementType\": \"labels.icon\", \"stylers\": [ { \"hue\": \"#0a00ff\" }, { \"saturation\": \"-77\" }, { \"gamma\": \"0.57\" }, { \"lightness\": \"0\" } ] }, { \"featureType\": \"transit.station.rail\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"color\": \"#43321e\" } ] }, { \"featureType\": \"transit.station.rail\", \"elementType\": \"labels.icon\", \"stylers\": [ { \"hue\": \"#ff6c00\" }, { \"lightness\": \"4\" }, { \"gamma\": \"0.75\" }, { \"saturation\": \"-68\" } ] }, { \"featureType\": \"water\", \"elementType\": \"all\", \"stylers\": [ { \"color\": \"#eaf6f8\" }, { \"visibility\": \"on\" } ] }, { \"featureType\": \"water\", \"elementType\": \"geometry.fill\", \"stylers\": [ { \"color\": \"#c7eced\" } ] }, { \"featureType\": \"water\", \"elementType\": \"labels.text.fill\", \"stylers\": [ { \"lightness\": \"-49\" }, { \"saturation\": \"-53\" }, { \"gamma\": \"0.79\" } ] } ]",
        },
        dsbl_btn: false,

        // Map
        meta_title: '',
        meta_description: '',
        meta_keywords: '',
        meta_url: '',
        meta_image: '',
        loading: false,
        mobile_map: false,
        windowWidth: window.innerWidth,
        min_cluster: 15,
        zoom: 8,
        view: false,
        center: { lat: 0, lng: 0 },
        listings: [],
        listing: [],
        markers: [],
        places: [],
        currentPlace: null,
        pagination: {},
        fetchListingsFilters: {
          paginate: 100,
          page: 1,
          swLat: 0,
          swLng: 0,
          neLat: 0,
          neLng: 0,
          listings_source: 'listings',
          selects: [
            'id',
            'ListingId',
            'StandardStatus',
            'ListingContractDate',
            'PropertyType',
            'ListPrice',
            'ClosePrice',
            'thumbnail',
            'Address',
            'UnitNumber',
            'City',
            'StateOrProvince',
            'PostalCode',
            'mls_title',
            'BedroomsTotal',
            'BathroomsTotalInteger',
            'LivingArea',
            'LotSizeAcres',
            'ListOfficeName',
            'Latitude',
            'Longitude',
            'PhotosCount',
          ],
          wheres: {
            ListOfficeName: '',
          },
          whereins: {
            StandardStatus: ['Active','Active Under Contract','Pending'], // Closed
            PropertyType: [],
          },
          minmaxs: {
            BedroomsTotal: { min: '', max: ''},
            BathroomsTotalInteger: { min: '', max: '', cast: 'DECIMAL(10,2)'},
            ListPrice: { min: '', max: '', cast: 'DECIMAL(10,2)'},
            LivingArea: { min: '', max: '', cast: 'DECIMAL(10,2)'},
            LotSizeAcres: { min: '', max: '', cast: 'DECIMAL(10,2)'},
          }
        },

        // Filters
        tab: '',
        stages: [
          {id: 'Active', name: 'Active', active: true},
          {id: 'Active Under Contract', name: 'Active Under Contract', active: true},
          {id: 'Pending', name: 'Pending', active: true},
          // {id: 'Closed', name: 'Closed', active: true},
        ],
        dwelling_types: [
          {id: 'Single Family', name: 'Single Family', active: false},
          {id: 'Multiple Dwelling', name: 'Multiple Dwelling', active: false},
          {id: 'Land or Lot', name: 'Land or Lot', active: false},
        ],

        // Listing
        show_share: false,
        show_offer: false,
        show_login: false,

        calc_price: 0,
        calc_down: 10000,
        calc_years: 30,
        calc_rate: 5,
        calc_taxes: 0,
        calc_home_insurance: 0,
        calc_mortgage_insurance: 0,
        calc_total: 0,
        editing: 'none',

        request_showing_complete: false,
        request_showing_form: {
          name: '',
          email: '',
          phone: '',
          ListingId: '',
          Address: '',
          City: '',
          StateOrProvince: '',
          PostalCode: '',
          Longitude: '',
          Latitude: '',
          BedroomsTotal: '',
          BathroomsTotalInteger: '',
          LivingArea: '',
          ListPrice: '',
          comments: "I'm interested in this property!",
          // buying: false,
          // has_realtor: false,
          recaptcha_token: '',
        },
        
        make_offer_complete: false,
        make_offer_form: {
          name: '',
          email: '',
          phone: '',
          ListingId: '',
          Address: '',
          City: '',
          StateOrProvince: '',
          PostalCode: '',
          Longitude: '',
          Latitude: '',
          BedroomsTotal: '',
          BathroomsTotalInteger: '',
          LivingArea: '',
          ListPrice: '',
          offer_amount: 0,
          pre_qualified: '',
          comments: "I'm interested in making an offer on this property!",
          // buying: false,
          // has_realtor: false,
          recaptcha_token: '',
        },

      }
    },
    watch: {
      tab: { handler(n, o) { if(!n) { this.fetchListings(false); } } },
    },
    computed: {
      days_on_market() {
        if(this.listing.StandardStatus && ["Coming Soon", "Active", "Active Under Contract", "Pending"].includes(this.listing.StandardStatus)) {
          return this.moment().diff(this.moment(this.listing.OriginalEntryTimestamp), 'days');
        } else {
          return '';
        }
      },
      price_sqft() {
        var out = '';
        if(this.listing.ListPrice && this.listing.LivingArea) { out = this.formatPrice(this.listing.ListPrice/this.listing.LivingArea); }
        return out;
      }
    },
    mounted() {
      if(this.type != 'editor') {
        this.$nextTick(() => { window.addEventListener('resize', this.onResize); });

        if(this.user) {
          if(this.user.name) { this.request_showing_form.name = this.make_offer_form.name = this.user.name; }
          if(this.user.email) { this.request_showing_form.email = this.make_offer_form.email = this.user.email; }
          if(this.user.phone) { this.request_showing_form.phone  = this.make_offer_form.phone = this.user.phone; }
        }
      }
    },
    beforeDestroy() {
      if(this.type != 'editor') {
        window.removeEventListener('resize', this.onResize);
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }

      if(this.type != 'editor') {
        if(this.pc.disable_scroll) { $('body').addClass("no-scroll-page"); }
        GoogleMapsLoader.KEY = this.google_key;
        if(this.pc.listings_source) { this.fetchListingsFilters.listings_source = this.pc.listings_source; }
        if(this.pc.latitude) { this.center.lat = parseFloat(this.pc.latitude); }
        if(this.pc.longitude) { this.center.lng = parseFloat(this.pc.longitude); }
        if(this.pc.zoom) { this.zoom = parseInt(this.pc.zoom); }

        this.meta_title = document.querySelector('head title').textContent ? document.querySelector('head title').textContent: '';
        this.meta_description = document.querySelector('head meta[name="description"]').getAttribute('content') ? document.querySelector('head meta[name="description"]').content : '';
        this.meta_keywords = document.querySelector('head meta[name="keywords"]').getAttribute('content') ? document.querySelector('head meta[name="keywords"]').content : '';
        this.meta_url = document.querySelector('head link[rel="canonical"]').getAttribute('href') ? document.querySelector('head link[rel="canonical"]').href : '';
        this.meta_image = document.querySelector('head link[rel="image_src"]').getAttribute('href') ? document.querySelector('head link[rel="image_src"]').href : '';

        this.initMap();

        window.onpopstate = res => {
          this.isbusy = true;
          var params = this.getUrlParams();
          var pagetest = window.location.pathname.replace('/listings','').replace('/','');
            // console.log(params);
          if(pagetest) {
            this.$http.get('/mlss/fetch-listings', {params: {wheres:{ListingId: parseInt(pagetest)}}}).then(res => {
              // console.log(res);
              if(res.data.data.length == 1){ this.listing = res.body.data[0]; this.view = true; }
            }).catch(res => { this.popupErrors(res); });
          } else { this.view = false; }
          if(params.lat && params.lng) {
            if(params.zoom){ mapBig.setZoom(parseInt(params.zoom)); }
            mapBig.setCenter({ lat: parseFloat(params.lat), lng: parseFloat(params.lng) });
            this.fetchListings(false);
          }
          this.isbusy = false;
        };
      }
    },
    methods: {
      onResize() {
        this.windowWidth = window.innerWidth;
      },
      initMap() {
        var self = this;
        var params = this.getUrlParams();
        if(params['zoom']) { self.zoom = parseInt(params['zoom']); }
        GoogleMapsLoader.load(function(google) {
          if(self.search) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({'address': self.search}, function(results, status) {
              if(status === 'OK') {
                // console.log(results[0]);
                // console.log(self.search);
                self.center = results[0].geometry.location;
                document.getElementById("mapBigSearch").value = results[0].formatted_address;
              }
              self.launchMap(google);
            });
          } else if(params['lat'] && params['lng']) {
            self.center = new google.maps.LatLng(params['lat'], params['lng']);
            self.launchMap(google);
          // } else if(navigator.geolocation) { // Disabled browser geolocation which centers the map on the visitor location.
          //   navigator.geolocation.getCurrentPosition(function(position){
          //     self.center = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          //     self.launchMap(google);
          //   },
          //   function (error) {
          //     self.launchMap(google);
          //   });
          } else { self.launchMap(google); }
        });
      },
      launchMap(google) {
        var self = this;
        mapBig = new google.maps.Map(document.getElementById("mapBig"), {
          zoom: self.zoom,
          center: self.center,
          gestureHandling: 'greedy',
          streetViewControl: false,
          fullscreenControl: false,
          styles: (self.pc.map_google_style ? JSON.parse(self.pc.map_google_style) : '')
        });
        MarkerWithLabel = require('markerwithlabel')(google.maps);
        markerCluster = new MarkerClusterer(mapBig, [], {minimumClusterSize: self.min_cluster, zoomOnClick: false, styles: [
            { url: "/images/m1.png", height: 53, width: 53 },
            { url: "/images/m2.png", height: 53, width: 53 },
            { url: "/images/m3.png", height: 53, width: 53 },
            { url: "/images/m4.png", height: 53, width: 53 },
            { url: "/images/m5.png", height: 53, width: 53 }
          ]
        });
        searchBox = new google.maps.places.SearchBox(document.getElementById("mapBigSearch"));

        // Load listing if ListingId in URL
        var loadId = window.location.pathname.replace('/listings','').replace('/','').replace(/[^a-z0-9]/gi, '');
        if(loadId) { this.viewListing(loadId); }

        mapBig.addListener('tilesloaded', (evt) => { console.log("tilesloaded"); if(!self.isbusy){ self.fetchListings(); } },{ once: true });
        mapBig.addListener('dragend', (evt => { console.log("dragend"); if(!self.isbusy){ self.fetchListings(); } }));
        mapBig.addListener('zoom_changed', (evt => { console.log("zoom_changed"); if(!self.isbusy){ self.fetchListings(); } }));
        searchBox.addListener('places_changed', (evt => {
          console.log("places_changed");
          if(!self.isbusy){
            var places = searchBox.getPlaces(); if (places.length == 0) { return; }
            var bounds = new google.maps.LatLngBounds(); places.forEach(function(place) { if (!place.geometry) { return; } if (place.geometry.viewport) { bounds.union(place.geometry.viewport); } else { bounds.extend(place.geometry.location); }
            });
            // console.log(bounds);
            mapBig.fitBounds(bounds);
            self.fetchListings();
          }
        }));
        if(navigator.userAgent.indexOf("Firefox") > 0) {
          console.log("Zooming map in and out in an attempt to correct Firefox map bug.");
          mapBig.addListener('idle', (evt) => {
            self.isbusy = true; setTimeout(() => { mapBig.setZoom(mapBig.getZoom()-1); setTimeout(() => { self.isbusy = false; mapBig.setZoom(mapBig.getZoom()+1);  },500); },800);
          },{ once: true });
        }
      },
      fetchListings(push = true) {
        var startTime = Date.now();
        this.loading = true;
        this.fetchListingsFilters.page = this.pagination.current_page;
        var bounds = mapBig.getBounds();
        var swPoint = bounds.getSouthWest();
        var nePoint = bounds.getNorthEast();
        searchBox.setBounds(bounds);
        this.fetchListingsFilters.swLat = swPoint.lat();
        this.fetchListingsFilters.swLng = swPoint.lng();
        this.fetchListingsFilters.neLat = nePoint.lat();
        this.fetchListingsFilters.neLng = nePoint.lng();
        var params = this.setUrlParam(this.getUrlParams(), 'lat', mapBig.center.lat());
        params = this.setUrlParam(params, 'lng', mapBig.center.lng());
        params = this.setUrlParam(params, 'zoom', mapBig.zoom);
        var out = '?'; for (var i in params) { out += i+"="+encodeURIComponent(params[i])+"&"; } out = out.replace(/&$/, "");
        if(push) { history.pushState({}, null, document.location.pathname+out); }
        this.$http.get('/mlss/fetch-listings', {params: this.fetchListingsFilters}).then(res => {
          // console.log(res);
          this.listings = res.data.data;
          this.pagination = res.data;
          this.setMarkers();
          this.loading = false;
          var endTime = Date.now();
          console.log("Time Elapsed listings : ", ((endTime-startTime) / 1000.0).toFixed(2) + ' seconds');
        }).catch(res => { this.popupErrors(res); this.loading = false; });
      },
      setMarkers() {
        var self = this;
        markerCluster.clearMarkers();
        var markers = this.listings.map(function(listing) {
          var label_class = "rounded bubble _c-pointer";
          if(listing.ListOfficeName && listing.ListOfficeName.toLowerCase() == self.website_id){
            label_class = label_class+" btn-"+self.pc.map_bub_company_color;
          } else if(listing.StandardStatus && listing.StandardStatus == "Closed"){
            label_class = label_class+" btn-"+self.pc.map_bub_closed_color;
          } else {
            label_class = label_class+" btn-"+self.pc.map_bub_active_color;
          }
          var marker = new MarkerWithLabel({
            position: new google.maps.LatLng(listing.Latitude,listing.Longitude),
            labelContent: listing.StandardStatus == "Closed" ? self.truncatePrice(listing.ClosePrice) : self.truncatePrice(listing.ListPrice),
            labelAnchor: new google.maps.Point(19, 20),
            labelClass: label_class, // the CSS class for the label
            // labelStyle: {opacity: 0.75},
            info: listing.ListingId,
            icon: " "
          });
          google.maps.event.addListener(marker, 'click', function() {
            var myElement = document.getElementById('listing'+this.info);
            myElement.click();
            var topPos = myElement.offsetTop;
            $("[id^='listing']").css('border','none');
            $('#listing'+this.info).css({'border':'5px solid #ffd86c'});
            document.getElementById('scrolling_div').scrollTop = topPos;
          });
          google.maps.event.addListener(marker, 'mouseover', function() {
            marker.set("labelClass", ""+marker.labelClass+" hovered");
          });
          google.maps.event.addListener(marker, 'mouseout', function() {
            marker.set("labelClass", marker.labelClass.replace(" hovered",""));
          });
          return marker;
        });
        markerCluster.addMarkers(markers);
      },
      setUrlParam(params, key, value) {
        if(key && params[key]) { if(value) { params[key] = value; } else { delete params[key]; } } else if(key && value) { params[key] = value; }
        return params;
      },
      getUrlParams() {
        var urlParams = {}, match, pl = /\+/g, search = /([^&=]+)=?([^&]*)/g, decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); }, query  = window.location.search.substring(1);
        while (match = search.exec(query)) urlParams[decode(match[1])] = decode(match[2]); return urlParams;
      },
      viewListing(ListingId) {
        this.loading = true;
        this.$http.get('/mlss/fetch-listings', {params: {listings_source: this.fetchListingsFilters.listings_source, wheres:{ListingId: ListingId}, withs:{mls:{total:0},favorites:{total:0,wheres:{user_id: this.user && this.user.id ? this.user.id : 'aa'}}}}}).then(res => {
          // console.log(res);
          if(res.data.data.length > 0){
            var out = [], params = this.getUrlParams();
            for (var key in params) { if (params.hasOwnProperty(key)) { out.push(key + '=' + encodeURIComponent(params[key])); } }
            history.pushState({}, null, '/listings/'+ListingId+"?"+out.join('&'));
            this.listing = res.data.data[0];
            
            this.calc_price = Math.floor(this.listing.ListPrice);
            this.calc_mortgage_insurance = Math.floor((0.01 * this.listing.ListPrice) / 12);

            // Title
            var full_address = this.listing.Address+" "+this.listing.City+" "+this.listing.StateOrProvince+" "+this.listing.PostalCode;
            var mTitle = document.querySelector('head title'); mTitle.textContent = full_address+" | "+this.app_name;
            var mTitleOg = document.querySelector('head meta[property="og:title"]'); mTitleOg.setAttribute('content', full_address+" | "+this.app_name);
            var mTitleOgSite = document.querySelector('head meta[property="og:site_name"]'); mTitleOgSite.setAttribute('content', full_address+" | "+this.app_name);
            var mTitleTw = document.querySelector('head meta[name="twitter:title"]'); mTitleTw.setAttribute('content', full_address+" | "+this.app_name);

            // Description
            var mDesc = document.querySelector('head meta[name="description"]'); mDesc.setAttribute('content', this.listing.PublicRemarks);
            var mDescOg = document.querySelector('head meta[property="og:description"]'); mDescOg.setAttribute('content', this.listing.PublicRemarks);
            var mDescTw = document.querySelector('head meta[name="twitter:description"]'); mDescTw.setAttribute('content', this.listing.PublicRemarks);

            // Keywords
            var mKey = document.querySelector('head meta[name="keywords"]'); mKey.setAttribute('content', full_address);

            // URL
            var outUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
            var mUrl = document.querySelector('head link[rel="canonical"]'); mUrl.setAttribute('href', outUrl);
            var mUrlOg = document.querySelector('head meta[property="og:url"]'); mUrlOg.setAttribute('content', outUrl);

            // Image
            var mImage = document.querySelector('head link[rel="image_src"]'); mImage.setAttribute('href', this.listing.thumbnail);
            var mImageOg = document.querySelector('head meta[property="og:image"]'); mImageOg.setAttribute('content', this.listing.thumbnail);

            if(this.listing.ListingId) { this.request_showing_form.ListingId = this.make_offer_form.ListingId = this.listing.ListingId; }
            if(this.listing.Address) { this.request_showing_form.Address = this.make_offer_form.Address = this.listing.Address; }
            if(this.listing.City) { this.request_showing_form.City = this.make_offer_form.City = this.listing.City; }
            if(this.listing.StateOrProvince) { this.request_showing_form.StateOrProvince = this.make_offer_form.StateOrProvince = this.listing.StateOrProvince; }
            if(this.listing.PostalCode) { this.request_showing_form.PostalCode = this.make_offer_form.PostalCode = this.listing.PostalCode; }
            if(this.listing.Longitude) { this.request_showing_form.Longitude = this.make_offer_form.Longitude = this.listing.Longitude; }
            if(this.listing.Latitude) { this.request_showing_form.Latitude = this.make_offer_form.Latitude = this.listing.Latitude; }
            if(this.listing.BedroomsTotal) { this.request_showing_form.BedroomsTotal = this.make_offer_form.BedroomsTotal = parseFloat(this.listing.BedroomsTotal); }
            if(this.listing.BathroomsTotalInteger) { this.request_showing_form.BathroomsTotalInteger = this.make_offer_form.BathroomsTotalInteger = parseFloat(this.listing.BathroomsTotalInteger); }
            if(this.listing.LivingArea) { this.request_showing_form.LivingArea = this.make_offer_form.LivingArea = parseFloat(this.listing.LivingArea); }
            if(this.listing.ListPrice) { this.request_showing_form.ListPrice = this.make_offer_form.ListPrice = this.listing.ListPrice; }

            this.view = true;
          } else {
            alert("Listing could not be found");
          }
          this.loading = false;
        }).catch(res => { this.popupErrors(res); this.loading = false; });
      },
      closeListing() {
        var out = [], params = this.getUrlParams();
        for (var key in params) { if (params.hasOwnProperty(key)) { out.push(key + '=' + encodeURIComponent(params[key])); } }
        history.pushState({}, null, '/listings'+"?"+out.join('&'));

        // Title
        var mTitle = document.querySelector('head title'); mTitle.textContent = this.meta_title;
        var mTitleOg = document.querySelector('head meta[property="og:title"]'); mTitleOg.setAttribute('content', this.meta_title);
        var mTitleOgSite = document.querySelector('head meta[property="og:site_name"]'); mTitleOgSite.setAttribute('content', this.meta_title);
        var mTitleTw = document.querySelector('head meta[name="twitter:title"]'); mTitleTw.setAttribute('content', this.meta_title);

        // Description
        var mDesc = document.querySelector('head meta[name="description"]'); mDesc.setAttribute('content', this.meta_description);
        var mDescOg = document.querySelector('head meta[property="og:description"]'); mDescOg.setAttribute('content', this.meta_description);
        var mDescTw = document.querySelector('head meta[name="twitter:description"]'); mDescTw.setAttribute('content', this.meta_description);

        // Keywords
        var mKey = document.querySelector('head meta[name="keywords"]'); mKey.setAttribute('content', this.meta_title);

        // URL
        var mUrl = document.querySelector('head link[rel="canonical"]'); mUrl.setAttribute('href', this.meta_url);
        var mUrlOg = document.querySelector('head meta[property="og:url"]'); mUrlOg.setAttribute('content', this.meta_url);

        // Image
        var mImage = document.querySelector('head link[rel="image_src"]'); mImage.setAttribute('href', this.meta_image);
        var mImageOg = document.querySelector('head meta[property="og:image"]'); mImageOg.setAttribute('content', this.meta_image);

        this.request_showing_complete = false;
        this.make_offer_complete = false;

        this.view = false;
      },
      truncatePrice(value) {
        if (value >= 1000000000) { return (value / 1000000000).toFixed(1).replace(/\.0$/, '').substring(0, 3) + 'B'; }
        if (value >= 1000000) { return (value / 1000000).toFixed(1).replace(/\.0$/, '').substring(0, 3) + 'M'; }
        if (value >= 1000) { return (value / 1000).toFixed(1).replace(/\.0$/, '').substring(0, 3) + 'K'; }
        return value;
      },
      triggerPlace() {
        var input = document.getElementById('mapBigSearch');
        google.maps.event.trigger(input, 'focus', {});
        google.maps.event.trigger(input, 'keydown', { keyCode: 13 });
        google.maps.event.trigger(this, 'focus', {});
      },
      closeListingMessage() {
        setTimeout(() => { if(this.view) { this.$noty.warning('Double click to close listing.'); } }, 1000);
      },
      setWhereIns(items,filters,wherein) {
        var temp = [], all = true; for(var i in this[items]) { if(this[items][i].active) { temp.push(this[items][i].id); } else { all = false; } }

        var path = filters.split('.');
        var obj = this;
        for(var i in path) { obj = obj[path[i]]; }
        if(all) { obj.whereins[wherein] = ""; } else { obj.whereins[wherein] = temp; }
      },
      toggleFilter(filter,items,filters,wherein) {
        if(filter.active) { filter.active = false; } else { filter.active = true; }
        this.setWhereIns(items,filters,wherein);
      },
      async request_showing() {
        if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
        this.request_showing_form.recaptcha_token = await this.getRecaptcha();
        if(
          !this.request_showing_form.recaptcha_token ||
          this.request_showing_form.recaptcha_token == 'failed'
        ) {
          this.$noty.error("There was an issue with the Google ReCaptcha validation. Please try submitting the form again. If that does not work, try refreshing the page. If this does not solve the issue, please reach out to us.");
          this.loading = false; return;
        }
        this.$http.post('/inbox/request-showing', this.request_showing_form).then(res => {
          // console.log(res);
          if(res.data.message != null && res.data.message.length > 0){ this.$noty.success(res.data.message); }
          this.request_showing_complete = true;
          this.dsbl_btn = false;
        }).catch(res => {
          this.popupErrors(res);
          this.dsbl_btn = false;
        });
      },
      async make_offer() {
        if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
        this.make_offer_form.recaptcha_token = await this.getRecaptcha();
        if(
          !this.make_offer_form.recaptcha_token ||
          this.make_offer_form.recaptcha_token == 'failed'
        ) {
          this.$noty.error("There was an issue with the Google ReCaptcha validation. Please try submitting the form again. If that does not work, try refreshing the page. If this does not solve the issue, please reach out to us.");
          this.loading = false; return;
        }
        this.$http.post('/inbox/make-offer', this.make_offer_form).then(res => {
          // console.log(res);
          if(res.data.message != null && res.data.message.length > 0){ this.$noty.success(res.data.message); }
          this.make_offer_complete = true;
          this.dsbl_btn = false;
        }).catch(res => {
          this.popupErrors(res);
          this.dsbl_btn = false;
        });
      },
      saveFavorite() {
        if(this.disabled == true) { this.$noty.warning('Disabled'); return; } this.disabled = true;
        this.$http.post('/web/favorite', {ListingId: this.listing.ListingId}).then(res => {
          // console.log(res);
          if(res.data.created == 'yes') { this.listing.favorites.push(res.data.data); }
          else { this.listing.favorites = []; }
          if(res.data.message != null && res.data.message.length > 0){ this.$noty.success(res.data.message); }
          this.disabled = false;
        }).catch(res => { this.popupErrors(res); this.disabled = false; });
      },
      calculateMortgage() {
        this.calc_total = (this.calc_price - this.calc_down) * (this.calc_rate / 1200) / (1 - (Math.pow(1/(1 + (this.calc_rate / 1200)), (12 * this.calc_years)))) + (this.calc_taxes / 12) + (this.calc_home_insurance / 12) + this.calc_mortgage_insurance;
        // this.calc_total = this.calc_total + (this.calc_taxes / 12);
        // this.calc_total = this.calc_total + (this.calc_home_insurance / 12);
        // this.calc_total = this.calc_total + this.calc_mortgage_insurance;
      },
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <!-- <pre>{{pc}}</pre> -->
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Map settings :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.listings_source" Title="Listings source :" :Options="[
              {name:'Submitted listings',value:'listings'},
              {name:'MLS listings',value:'mls_listings'},
              {name:'MLS API listings',value:'api_listings'}
            ]" v-tippy content=""></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.latitude" Title="Starting latitude :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.longitude" Title="Starting longitude :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.zoom" Title="Starting zoom :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.disable_scroll" Title="Disable page scrolling? :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content=""></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Filters styling :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.filt_bg_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Button color :" :Options="theme_colors" v-model="pc.filt_btn_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Button border color :" :Options="theme_colors" v-model="pc.filt_btn_border_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Button active border color :" :Options="theme_colors" v-model="pc.filt_btn_active_border_color"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Results styling :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.res_bg_color" Title="Background color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.h1" Title="H1 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.h1_color" Title="H1 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Textarea" v-model="pc.h1_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.h1_desc_color" Title="H1 description color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.box_bg_color" Title="Listing box background color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.box_title_color" Title="Listing box title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.box_text_color" Title="Listing box text color : " :Options="theme_colors"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Map styling :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.map_bub_active_color" Title="Active bubble color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.map_bub_closed_color" Title="Closed bubble color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.map_bub_company_color" Title="Company bubble color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-12">
            <w-field SimpleDataType="Textarea" v-model="pc.map_google_style" Title="Google maps style snippet :" v-tippy content=""></w-field>
          </div>
        </div>


      </div>
    </div>

    <div v-else>

      <div class="position-absolute _pos-l-0 _pos-r-0 _z-100 border-top border-bottom" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
        <perfect-scrollbar class="p-2 w-100 slim-scroll-x">
          <ul class="nav flex-nowrap text-nowrap">
            <li class="nav-item">
              <div class="input-group _w-n-200">
                <input id="mapBigSearch" type="text" name="address" placeholder="Address, City, State or Zip..." class="form-control form-control-sm _h-37 _f-s-11" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                <div class="input-group-append">
                  <button type="button" class="btn btn-sm _h-37" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" @click="triggerPlace()"><Icon icon="ri:search-2-line"></Icon></button>
                </div>
              </div>
            </li>
            <li class="nav-item ml-2"><button type="button" class="btn btn-sm _h-37 font-weight-600 _f-s-13"
              :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(tab == 'status' || (fetchListingsFilters.whereins.StandardStatus && fetchListingsFilters.whereins.StandardStatus.length) ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
              @click="tab == 'status' ? tab = '' : tab = 'status'"><Icon icon="ri:home-7-line"></Icon> Status</button>
            </li>
            <li class="nav-item ml-2"><button type="button" class="btn btn-sm _h-37 font-weight-600 _f-s-13"
              :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(tab == 'type' || (fetchListingsFilters.whereins.PropertyType && fetchListingsFilters.whereins.PropertyType.length) ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
              @click="tab == 'type' ? tab = '' : tab = 'type'"><Icon icon="ri:building-line"></Icon> Property type</button>
            </li>
            <li class="nav-item ml-2"><button type="button" class="btn btn-sm _h-37 font-weight-600 _f-s-13"
              :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(tab == 'bedrooms' || (fetchListingsFilters.minmaxs.BedroomsTotal.min || fetchListingsFilters.minmaxs.BedroomsTotal.max) ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
              @click="tab == 'bedrooms' ? tab = '' : tab = 'bedrooms'"><Icon icon="ri:hotel-bed-line"></Icon> Bedrooms</button></button>
            </li>
            <li class="nav-item ml-2"><button type="button" class="btn btn-sm _h-37 font-weight-600 _f-s-13"
              :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(tab == 'bathrooms' || (fetchListingsFilters.minmaxs.BathroomsTotalInteger.min || fetchListingsFilters.minmaxs.BathroomsTotalInteger.max) ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
              @click="tab == 'bathrooms' ? tab = '' : tab = 'bathrooms'"><Icon icon="ri:contrast-drop-line"></Icon> Bathrooms</button></button>
            </li>
            <li class="nav-item ml-2"><button type="button" class="btn btn-sm _h-37 font-weight-600 _f-s-13"
              :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(tab == 'price' || (fetchListingsFilters.minmaxs.ListPrice.min || fetchListingsFilters.minmaxs.ListPrice.max) ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
              @click="tab == 'price' ? tab = '' : tab = 'price'"><Icon icon="ri:money-dollar-box-line"></Icon> Price</button></button>
            </li>
            <li class="nav-item ml-2"><button type="button" class="btn btn-sm _h-37 font-weight-600 _f-s-13"
              :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(tab == 'sqft' || (fetchListingsFilters.minmaxs.LivingArea.min || fetchListingsFilters.minmaxs.LivingArea.max) ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
              @click="tab == 'sqft' ? tab = '' : tab = 'sqft'"><Icon icon="ri:ruler-2-line"></Icon> SQFT</button></button>
            </li>
            <li class="nav-item ml-2"><button type="button" class="btn btn-sm _h-37 font-weight-600 _f-s-13"
              :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(tab == 'lot_size' || (fetchListingsFilters.minmaxs.LotSizeAcres.min || fetchListingsFilters.minmaxs.LotSizeAcres.max) ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
              @click="tab == 'lot_size' ? tab = '' : tab = 'lot_size'"><Icon icon="ri:pencil-ruler-line"></Icon> Lot size</button></button>
            </li>
            <li class="nav-item p-2"></li>
          </ul>
        </perfect-scrollbar>
      </div>

      <div class="position-absolute _pos-l-0 _pos-t-55 _pos-r-0 _z-99">
        <perfect-scrollbar class="_h-m-100vh-n-115">
          <transition name="fadeDown" mode="out-in">
            <div v-if="tab" key="drop-filters" class="row m-0" @click.self="tab = ''">
              <div v-if="tab == 'status'" key="status" class="col-sm-3 p-0 border-right border-bottom" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                <div class="p-3 border-bottom" :class="'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                  <a class="float-right _lh-14" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')" @click="tab = ''" v-tippy content="Close this dropdown menu and commit changes."><Icon icon="ri:close-line" width="20"></Icon></a>
                  <h6 class="mb-0" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')"><Icon icon="ri:home-7-line"></Icon> Status</h6>
                </div>
                <div class="p-3">
                  <button v-for="(filt, filt_i) in stages" :key="filt.id" type="button" class="btn btn-block text-left mb-2"
                    :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(filt.active ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
                    @click="toggleFilter(filt,'stages','fetchListingsFilters','StandardStatus')">
                    <Icon v-if="filt.active" icon="ri:checkbox-circle-line" height="20" :class="'text-'+(pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '')"></Icon>
                    <Icon v-else icon="ri:checkbox-blank-circle-line" height="20" :class="'text-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')"></Icon>
                    {{filt.name}}
                  </button>
                </div>
              </div>
              <div v-if="tab == 'type'" key="type" class="col-sm-3 p-0 border-right border-bottom" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                <div class="p-3 border-bottom" :class="'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                  <a class="float-right _lh-14" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')" @click="tab = ''" v-tippy content="Close this dropdown menu and commit changes."><Icon icon="ri:close-line" width="20"></Icon></a>
                  <h6 class="mb-0" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')"><Icon icon="ri:building-line"></Icon> Property type</h6>
                </div>
                <div class="p-3">
                  <button v-for="(filt, filt_i) in dwelling_types" :key="filt.id" type="button" class="btn btn-block text-left mb-2"
                    :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(filt.active ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
                    @click="toggleFilter(filt,'dwelling_types','fetchListingsFilters','PropertyType')">
                    <Icon v-if="filt.active" icon="ri:checkbox-circle-line" height="20" :class="'text-'+(pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '')"></Icon>
                    <Icon v-else icon="ri:checkbox-blank-circle-line" height="20" :class="'text-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')"></Icon>
                    {{filt.name}}
                  </button>
                </div>
              </div>
              <div v-if="tab == 'bedrooms'" key="bedrooms" class="col-sm-3 p-0 border-right border-bottom" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                <div class="p-3 border-bottom" :class="'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                  <a class="float-right _lh-14" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')" @click="tab = ''" v-tippy content="Close this dropdown menu and commit changes."><Icon icon="ri:close-line" width="20"></Icon></a>
                  <h6 class="mb-0" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')"><Icon icon="ri:hotel-bed-line"></Icon> Bedrooms</h6>
                </div>
                <div class="p-3">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group m-0">
                        <label for="" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')">Min</label>
                        <select class="form-control" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-model="fetchListingsFilters.minmaxs.BedroomsTotal.min">
                          <option value="">Any</option>
                          <option value="1">1+</option>
                          <option value="2">2+</option>
                          <option value="3">3+</option>
                          <option value="4">4+</option>
                          <option value="5">5+</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group m-0">
                        <label for="" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')">Max</label>
                        <select class="form-control" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-model="fetchListingsFilters.minmaxs.BedroomsTotal.max">
                          <option value="">Any</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="tab == 'bathrooms'" key="bathrooms" class="col-sm-3 p-0 border-right border-bottom" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                <div class="p-3 border-bottom" :class="'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                  <a class="float-right _lh-14" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')" @click="tab = ''" v-tippy content="Close this dropdown menu and commit changes."><Icon icon="ri:close-line" width="20"></Icon></a>
                  <h6 class="mb-0" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')"><Icon icon="ri:contrast-drop-line"></Icon> Bathrooms</h6>
                </div>
                <div class="p-3">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group m-0">
                        <label for="" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')">Min</label>
                        <select class="form-control" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-model="fetchListingsFilters.minmaxs.BathroomsTotalInteger.min">
                          <option value="">Any</option>
                          <option value="1">1+</option>
                          <option value="2">2+</option>
                          <option value="3">3+</option>
                          <option value="4">4+</option>
                          <option value="5">5+</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group m-0">
                        <label for="" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')">Max</label>
                        <select class="form-control" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-model="fetchListingsFilters.minmaxs.BathroomsTotalInteger.max">
                          <option value="">Any</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="tab == 'price'" key="price" class="col-sm-3 p-0 border-right border-bottom" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                <div class="p-3 border-bottom" :class="'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                  <a class="float-right _lh-14" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')" @click="tab = ''" v-tippy content="Close this dropdown menu and commit changes."><Icon icon="ri:close-line" width="20"></Icon></a>
                  <h6 class="mb-0" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')"><Icon icon="ri:money-dollar-box-line"></Icon> Price</button></h6>
                </div>
                <div class="p-3">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group m-0">
                        <label for="" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')">Min</label>
                        <select class="form-control" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-model="fetchListingsFilters.minmaxs.ListPrice.min">
                          <option value="">Any</option>
                          <option value="100000">$100,000+</option>
                          <option value="200000">$200,000+</option>
                          <option value="300000">$300,000+</option>
                          <option value="400000">$400,000+</option>
                          <option value="500000">$500,000+</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group m-0">
                        <label for="" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')">Max</label>
                        <select class="form-control" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-model="fetchListingsFilters.minmaxs.ListPrice.max">
                          <option value="">Any</option>
                          <option value="100000">$100,000</option>
                          <option value="200000">$200,000</option>
                          <option value="300000">$300,000</option>
                          <option value="400000">$400,000</option>
                          <option value="500000">$500,000</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="tab == 'sqft'" key="sqft" class="col-sm-3 p-0 border-right border-bottom" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                <div class="p-3 border-bottom" :class="'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                  <a class="float-right _lh-14" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')" @click="tab = ''" v-tippy content="Close this dropdown menu and commit changes."><Icon icon="ri:close-line" width="20"></Icon></a>
                  <h6 class="mb-0" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')"><Icon icon="ri:ruler-2-line"></Icon> SQFT</button></h6>
                </div>
                <div class="p-3">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group m-0">
                        <label for="" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')">Min</label>
                        <select class="form-control" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-model="fetchListingsFilters.minmaxs.LivingArea.min">
                          <option value="">Any</option>
                          <option value="1000">1,000+</option>
                          <option value="1500">1,500+</option>
                          <option value="2000">2,000+</option>
                          <option value="2500">2,500+</option>
                          <option value="3000">3,000+</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group m-0">
                        <label for="" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')">Max</label>
                        <select class="form-control" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-model="fetchListingsFilters.minmaxs.LivingArea.max">
                          <option value="">Any</option>
                          <option value="1000">1,000</option>
                          <option value="1500">1,500</option>
                          <option value="2000">2,000</option>
                          <option value="2500">2,500</option>
                          <option value="3000">3,000</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="tab == 'lot_size'" key="lot_size" class="col-sm-3 p-0 border-right border-bottom" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                <div class="p-3 border-bottom" :class="'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
                  <a class="float-right _lh-14" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')" @click="tab = ''" v-tippy content="Close this dropdown menu and commit changes."><Icon icon="ri:close-line" width="20"></Icon></a>
                  <h6 class="mb-0" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')"><Icon icon="ri:pencil-ruler-line"></Icon> Lot size</button></h6>
                </div>
                <div class="p-3">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group m-0">
                        <label for="" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')">Min</label>
                        <select class="form-control" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-model="fetchListingsFilters.minmaxs.LotSizeAcres.min">
                          <option value="">Any</option>
                          <option value="0.25">0.25 acres+</option>
                          <option value="0.5">0.5 acres+</option>
                          <option value="1">1 acres+</option>
                          <option value="1.5">1.5 acres+</option>
                          <option value="2">2 acres+</option>
                          <option value="3">3 acres+</option>
                          <option value="4">4 acres+</option>
                          <option value="5">5 acres+</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group m-0">
                        <label for="" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')">Max</label>
                        <select class="form-control" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-model="fetchListingsFilters.minmaxs.LotSizeAcres.max">
                          <option value="">Any</option>
                          <option value="0.25">0.25 acres</option>
                          <option value="0.5">0.5 acres</option>
                          <option value="1">1 acres</option>
                          <option value="1.5">1.5 acres</option>
                          <option value="2">2 acres</option>
                          <option value="3">3 acres</option>
                          <option value="4">4 acres</option>
                          <option value="5">5 acres</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </perfect-scrollbar>
      </div>

      <div class="position-absolute _pos-l-0 _pos-t-55 _pos-r-0 p-2 _z-98 border-bottom d-block d-md-none" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')">
        <div class="row m-0">
          <div class="col-6">
            <button type="button" class="btn btn-sm btn-block _h-37" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(!mobile_map ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
              @click="mobile_map = false"><Icon icon="ri:list-check"></Icon> View results</button>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-sm btn-block _h-37" :class="'btn-'+(pc.filt_btn_color ? pc.filt_btn_color : '')+' border-'+(mobile_map ? (pc.filt_btn_active_border_color ? pc.filt_btn_active_border_color : '') : (pc.filt_btn_border_color ? pc.filt_btn_border_color : ''))"
              @click="mobile_map = true"><Icon icon="ri:map-2-line"></Icon> View map</button>
          </div>
        </div>
      </div>

      <transition name="fade">
        <div v-if="view" class="position-fixed _pos-l-0 _pos-t-60 _pos-r-0 _pos-b-0 _z-100 _bg-c-t-fff-8">
          <div class="py-3 px-0 px-md-3 h-100 overflow-auto" @dblclick.self="closeListing()" @click.self="closeListingMessage()">
            <div class="container-fluid">

              <div v-if="listing.ListingId" class="bg-white _box-shadow-0-1-10-b-2 rounded">
                <div class="">
                  <div class="row mx-0 border-bottom border-light">
                    <div class="_w-80 d-none d-md-inline-block p-3 border-right border-light">
                      <img :src="formatImage('/fm/revinre-nc/clip art/Real Estate Listings.png')" :alt="(listing.Address+' '+listing.City+' '+listing.StateOrProvince+' '+listing.PostalCode).replace(/[^a-z0-9 ]/gi,'')">
                    </div>
                    <div class="col-12 col-sm p-3">
                      <div class="float-right">
                        <button type="button" class="btn btn-lg btn-white border-0" @click="closeListing()"><Icon icon="ri:close-line" width="30"></Icon></button>
                      </div>
                      <h1 class="h2 m-0">{{listing.Address}} <span class="d-block h6 m-0">{{listing.City}} {{listing.StateOrProvince}} {{listing.PostalCode}}</span></h1>
                      <p class="m-0"></p>
                    </div>
                  </div>
                </div>



                <div class="row m-0">
                  <div class="col-sm p-0 border-right border-light">

                    <w-listing-preview :item="listing" :pc="pc"></w-listing-preview>

                  </div>
                  <div class="_w-400 p-0">
                    <div class="p-2rem m_p-25 border-bottom border-light">
                      <button type="button" class="btn btn-block btn-lg mr-4" :class="'btn-'+website_id" @click="show_offer = true"><Icon icon="ri:mail-send-line"></Icon> Make an offer</button>
                      <transition name="fade">

                        <div v-if="show_offer" class="position-fixed _pos-l-0 _pos-t-60 _pos-r-0 _pos-b-0 _z-101 _bg-c-t-000-5">
                          <div class="py-3 px-0 px-md-3 h-100 overflow-auto" @click.self="show_offer = false">
                            <div class="container-fluid pt-5">
                              <div class="bg-white _box-shadow-0-1-10-b-2 rounded _w-m-1000 mx-auto">
                                <div class="float-right">
                                  <button type="button" class="btn btn-lg btn-white border-0 _h-75" @click="show_offer = false"><Icon icon="ri:close-line" width="30"></Icon></button>
                                </div>
                                <h3 class="p-4 mb-0">Make an offer</h3>
                                <div class="clearfix"></div>
                                <div class="p-4 border-top border-light">
                                  <div v-if="make_offer_complete" class="alert alert-success text-center p-5">
                                    <div class="mb-4"><Icon icon="ri:mail-send-line" height="100" class="" /></div>Your message has been sent!
                                  </div>
                                  <form v-else @submit.prevent="make_offer" id="make_offer">
                                    <div class="row">
                                      <div class="col-sm-5">
                                        <w-listing-box :item="listing" class="border _box-shadow-0-1-4-b-2 mb-4"></w-listing-box>
                                      </div>
                                      <div class="col-sm-7">
                                        <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Contact information :</h5>
                                        <w-field class="mb-3" SimpleDataType="String" v-model="make_offer_form.name" Title="Full name : " Size="lg" Required></w-field>
                                        <w-field class="mb-3" SimpleDataType="String" v-model="make_offer_form.email" Title="Email address : " Size="lg" Required></w-field>
                                        <w-field class="mb-3" SimpleDataType="Phone" v-model="make_offer_form.phone" Title="Phone Number : " Size="lg" :Required="!!parseInt(pc['phone_required'])"></w-field>
                                      </div>
                                    </div>
                                    <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Offer Details :</h5>
                                    <div class="row">
                                      <div class="col-sm-6">
                                        <w-field class="mb-3" SimpleDataType="Money" v-model="make_offer_form.offer_amount" :decimal="false" Title="Offer amount : " Size="lg" Required></w-field>
                                      </div>
                                      <div class="col-sm-6">
                                        <w-field class="mb-3" SimpleDataType="String List, Single" v-model="make_offer_form.pre_qualified" :Options="['Yes', 'No']" Title="Are you pre-qualified? : " Size="lg" Required></w-field>
                                      </div>
                                      <div class="col-sm-12">
                                        <w-field class="mb-3" SimpleDataType="Textarea" v-model="make_offer_form.comments" Title="Comments : " Size="lg" Required></w-field>
                                        <div class="small">
                                          <p class="small text-gray-700 mb-1">By submitting you agree to {{app_name}}'s <a href="/privacy" target="_blank">Privacy Policy</a> and <a href="/terms" target="_blank">Terms & Conditions</a>.</p>
                                          <p class="small text-gray-700 mb-2">This site is protected by ReCaptcha and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</p>
                                        </div>
                                        <button type="submit" class="btn btn-lg btn-block" :class="'btn-'+website_id" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:mail-send-line" /> Submit</button>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>

                    <div class="p-2rem m_p-25 border-bottom border-light">
                      <h3 class="mb-4"><Icon icon="ri:bookmark-line" width="23" class="mr-2" :class="'text-'+website_id"></Icon>Contact an agent</h3>
                      <img class="rounded _box-shadow-0-1-4-b-2" :src="formatImage(website.site_logo)" :alt="listing.Address+' '+listing.City+' '+listing.StateOrProvince+' '+listing.PostalCode">
                      <div class="mt-3">
                        <h4 class="">{{app_name}}</h4>
                        <p class=""><Icon icon="ri:phone-line" width="17" class="mr-2"></Icon> {{ formatPhone(website.site_phone) }}</p>
                        <p class=""><Icon icon="ri:mail-line" width="17" class="mr-2"></Icon> {{website.site_email}}</p>
                        <p class=""><Icon icon="ri-global-line" width="17" class="mr-2"></Icon> {{app_url}}</p>
                      </div>
                    </div>

                    <div class="p-2rem m_p-25 border-bottom border-light">
                      <h3 class="mb-4"><Icon icon="ri:bookmark-line" width="23" class="mr-2" :class="'text-'+website_id"></Icon>Request a showing</h3>
                      <transition name="fade" tag="div" mode="out-in">
                        <div v-if="request_showing_complete" class="alert alert-success text-center p-5">
                          <div class="mb-4"><Icon icon="ri:mail-send-line" height="100" class="" /></div>Your message has been sent!
                        </div>
                        <div v-else key="2" class="">
                          <form @submit.prevent="request_showing" id="request_showing">
                            <div class="form-group">
                              <label for="input-name">Full name <span class="text-danger">*</span></label>
                              <input id="input-name" name="name" type="text" class="form-control" v-model="request_showing_form.name" required>
                            </div>
                            <div class="form-group">
                              <label for="input-email">Email address <span class="text-danger">*</span></label>
                              <input id="input-email" name="email" type="text" class="form-control" v-model="request_showing_form.email" required>
                            </div>
                            <div class="form-group">
                              <label for="input-phone">Phone number <span class="text-danger">*</span></label>
                              <the-mask id="input-phone" name="phone" type="tel" class="form-control" v-model="request_showing_form.phone" :mask="['(###) ###-####']" required />
                            </div>
                            <div class="form-group">
                              <label for="input-comments">Comments <span class="text-danger">*</span></label>
                              <textarea id="input-comments" name="comments" class="form-control" rows="2" v-model="request_showing_form.comments" required></textarea>
                            </div>
                            <div class="small">
                              <p class="small text-gray-700 mb-1">By submitting you agree to {{app_name}}'s <a href="/privacy" target="_blank">Privacy Policy</a> and <a href="/terms" target="_blank">Terms & Conditions</a>.</p>
                              <p class="small text-gray-700 mb-2">This site is protected by ReCaptcha and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</p>
                            </div>
                            <button type="submit" class="btn btn-lg btn-block" :class="'btn-'+website_id" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:mail-send-line" /> Submit</button>
                          </form>
                        </div>
                      </transition>
                    </div>

                    <div class="p-2rem m_p-25 border-bottom border-light">
                      <h3 class="mb-4"><Icon icon="ri:bookmark-line" width="23" class="mr-2" :class="'text-'+website_id"></Icon>Mortage calculator</h3>
                      <div class="form-group">
                        <label for="input-calc_price">Home price <span class="text-danger">*</span></label>
                        <w-money id="input-calc_price" name="calc_price" class="form-control" placeholder="$" v-model="calc_price" :decimal="false" required></w-money>
                      </div>
                      <div class="form-group">
                        <label for="input-calc_down">Down payment <span class="text-danger">*</span></label>
                        <w-money id="input-calc_down" name="calc_down" class="form-control" placeholder="$" v-model="calc_down" :decimal="false" required></w-money>
                      </div>
                      <div class="form-group">
                        <label for="input-calc_years">Loan term <span class="text-danger">*</span></label>
                        <div class="input-group">
                          <input id="input-calc_years" name="calc_years" type="number" class="form-control" placeholder="Years" required v-model="calc_years">
                          <div class="input-group-append"><span class="input-group-text">Years</span></div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="input-calc_rate">Interest rate <span class="text-danger">*</span></label>
                        <div class="input-group">
                          <input id="input-calc_rate" name="calc_rate" type="number" class="form-control" placeholder="%" required v-model="calc_rate">
                          <div class="input-group-append"><span class="input-group-text">%</span></div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="input-calc_taxes">Property taxes <span class="text-danger">*</span></label>
                        <div class="input-group">
                          <w-money id="input-calc_taxes" name="calc_taxes" class="form-control" placeholder="$" v-model="calc_taxes" :decimal="false" required></w-money>
                          <div class="input-group-append"><span class="input-group-text">/year</span></div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="input-calc_home_insurance">Home insurance <span class="text-danger">*</span></label>
                        <div class="input-group">
                          <w-money id="input-calc_home_insurance" name="calc_home_insurance" class="form-control" placeholder="$" v-model="calc_home_insurance" :decimal="false" required></w-money>
                          <div class="input-group-append"><span class="input-group-text">/year</span></div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="input-calc_mortgage_insurance">Mortgage insurance <span class="text-danger">*</span></label>
                        <div class="input-group">
                          <w-money id="input-calc_mortgage_insurance" name="calc_mortgage_insurance" class="form-control" placeholder="$" v-model="calc_mortgage_insurance" :decimal="false" required></w-money>
                          <div class="input-group-append"><span class="input-group-text">/month</span></div>
                        </div>
                      </div>
                      <h4 v-if="calc_total > 0" class="text-success mb-3">{{formatPrice(calc_total)}} / month</h4>
                      <div class="small">
                        <p class="small text-gray-700 mb-2">All calculations are estimates and provided for informational purposes only. Actual amounts may vary.</p>
                      </div>
                      <div class="">
                        <button type="button" class="btn btn-lg btn-block" :class="'btn-'+website_id" @click="calculateMortgage()"><Icon icon="ri:calculator-line"></Icon> Calculate</button>
                      </div>
                    </div>

                  </div>
                </div>

                <w-site-footer class="bg-dark text-white px-3" :website="website" :aos="false"></w-site-footer>
              </div>
              <div v-else class="bg-white _box-shadow-0-1-10-b-2 rounded">
                <div class="">
                  <div class="row mx-0">
                    <div class="_w-150 p-5 border-right border-light">
                      <img src="/storage/fm/revinre-nc/clip art/Real Estate Listings.png" alt="Listing not found">
                    </div>
                    <div class="col-12 col-sm p-5">
                      <div class="float-right">
                        <button type="button" class="btn btn-outline-dark border-0 px-2 py-0 _f-s-30" @click="closeListing()"><Icon icon="ri:close-fill"></Icon></button>
                      </div>
                      <h2 class="h3">Listing not found</h2>
                      <p class="m-0">Close this popup to view the map</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </transition>

      <div class="row mx-0 _h-100vh-n-55 _p-t-55 m_p-t-110" :class="'bg-'+(pc.res_bg_color ? pc.res_bg_color : 'light')">
        <div class="col-md-6 col-lg-3 p-0 h-100 border-right" :class="'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')" v-show="windowWidth > 767 || !mobile_map">
          <div class="position-absolute _pos-t-0 _pos-l-0 _pos-r-0 _w-m-400 _z-98 mx-auto _b-r-bl-5 _b-r-br-5 py-1 px-3 text-center _f-s-11 font-weight-bold border-left border-bottom border-right d-block d-md-none" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')+' '+'text-'+(pc.map_count_text_color ? pc.map_count_text_color : '')">
            <i v-if="loading" class="spinner-border spinner-border-sm"></i>
            {{listings.length}} of {{pagination.total}} results. Adjust filters or map position to view more.
          </div>
          <div class="p-4 h-100 overflow-auto" id="scrolling_div">
            <div :class="(pc.h1 || pc.h1_desc ? 'pb-4' : '')">
              <h1 class="h2" :class="'text-'+(pc.h1_color ? pc.h1_color : '')+' '+(pc.h1 ? '' : 'm-0')">{{pc.h1 ? pc.h1 : ''}}</h1>
              <p class="" :class="'text-'+(pc.h1_desc_color ? pc.h1_desc_color : '')+' '+(pc.h1_desc ? '' : 'm-0')">{{pc.h1_desc ? pc.h1_desc : ''}}</p>
            </div>
            <div v-for="listing in listings" :key="listing.id" class="mb-4">
              <a @click.prevent="viewListing(listing.ListingId)" class="d-block" :id="'listing'+listing.ListingId" :href="'/listings/'+listing.ListingId">
                <w-listing-box :item="listing" class="border _box-shadow-0-1-4-b-2 mb-4"></w-listing-box>
              </a>
            </div>
            <div class="mb-5">
              <w-pagination :pagination="pagination" @paginate="listings=[]; fetchListings()" :offset="3" :center="true"></w-pagination>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-9 p-0 h-100">
          <div class="position-absolute _pos-t-0 _pos-l-0 _pos-r-0 _w-m-400 _z-98 mx-auto _b-r-bl-5 _b-r-br-5 py-1 px-3 text-center _f-s-11 font-weight-bold border-left border-bottom border-right" :class="'bg-'+(pc.filt_bg_color ? pc.filt_bg_color : 'white')+' '+'border-'+(pc.filt_btn_border_color ? pc.filt_btn_border_color : '')+' '+'text-'+(pc.map_count_text_color ? pc.map_count_text_color : '')">
            <i v-if="loading" class="spinner-border spinner-border-sm"></i>
            {{listings.length}} of {{pagination.total}} results. Adjust filters or map position to view more.
          </div>
          <div id="mapBig" class="h-100"></div>
        </div>
      </div>

    </div>

  </section>

</template>

<style>
.bubble {
  padding: .2rem .4rem;
  font-size: 11px;
  font-weight: 600;
  -webkit-transition:all .2s ease-in-out; -moz-transition:all .2s ease-in-out; transition:all .2s ease-in-out;
  will-change: transform;
}
.bubble.hovered {
  padding: .25rem .45rem;
  font-size: 12px;
}
</style>
